import {
  // 级联国家筛选器
  REGION as REGION_SELECT_FILTER,
  REGION_EXTEND_TYPE,
  // CheckboxGroup多选Mobile数据源 筛选器
  ICONABLE_CHECKBOX_SELECT as ICONABLE_CHECKBOX_SELECT_FILTER,
  // 是否显示热度国家筛选器
  HEAT_MAP as HEAT_MAP_SELECT_FILTER,
  // 是否显示前n个国家筛选器
  SHOW_TOP_COUNTRIES as SHOW_TOP_COUNTRIES_SELECT_FILTER,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

// 静态筛选器配置，即所有配置相关的都是常量，不需要通过组件props、组件其他state、组件其他变量来决定 可以单独写在一个js文件中
export const STATIC_FILTER_CONFIGS = {
  // 级联国家筛选器
  REGION_SELECT_FILTER: {
    key: REGION_SELECT_FILTER,
    type: REGION_SELECT_FILTER,
    extendFilterType: REGION_EXTEND_TYPE.common,
    visible: 1,
    disabled: false,
    // "popularList": [
    //   "br",
    //   "mx",
    //   "ru",
    //   "tr",
    //   "us"
    // ],
    options: [],
    entityType: 'mobile',
  },
  // CheckboxGroup多选Mobile数据源 筛选器
  ICONABLE_CHECKBOX_SELECT_FILTER: {
    key: ICONABLE_CHECKBOX_SELECT_FILTER,
    type: ICONABLE_CHECKBOX_SELECT_FILTER,
    visible: 1,
    disabled: false,
    className: 'dbi-compare-mobile__datasource-checkbox-select',
    options: [
      {
        value: 'appannie',
        text: 'data.ai',
        textEN: 'data.ai',
        textCN: 'data.ai',
      },
      {
        value: 'sensortower',
        text: 'Sensor Tower',
        textEN: 'Sensor Tower',
        textCN: 'Sensor Tower',
      },
    ],
  },
  // 是否显示热度国家筛选器
  HEAT_MAP_SELECT_FILTER: {
    key: HEAT_MAP_SELECT_FILTER,
    type: HEAT_MAP_SELECT_FILTER,
  },
  // 是否显示前n个国家筛选器
  SHOW_TOP_COUNTRIES_SELECT_FILTER: {
    key: SHOW_TOP_COUNTRIES_SELECT_FILTER,
    type: SHOW_TOP_COUNTRIES_SELECT_FILTER,
    num: 3,
  },
};

// 各个筛选器组件UI渲染需要的value
export const DEFAULT_FORM_VALUE = {
  // 级联国家筛选器
  [REGION_SELECT_FILTER]: {
    type: 'market',
    regions: [],
    markets: ['global'],
  },
  // CheckboxGroup多选Mobile数据源 筛选器
  [ICONABLE_CHECKBOX_SELECT_FILTER]: {
    value: ['sensortower'],
  },
  // 是否显示热度国家筛选器
  [HEAT_MAP_SELECT_FILTER]: {
    value: false,
  },
  // 是否显示前n个国家筛选器
  [SHOW_TOP_COUNTRIES_SELECT_FILTER]: {
    value: false,
  },
};
